module.exports = __webpack_public_path__ + "img/credt-card-grey.701257fe.svg";